(() => {
  const controllers = new WeakMap();

  function init(root) {
    controllers.get(root)?.abort();
    const controller = new AbortController();
    controllers.set(root, controller);
    const { signal } = controller;
    const buttons = [...root.querySelectorAll('[data-avz8-filter]')];
    const cards = [...root.querySelectorAll('[data-avz8-card]')];
    const result = root.querySelector('[data-avz8-results]');
    const empty = root.querySelector('[data-avz8-empty]');
    const shop = root.querySelector('#avz8-shop');

    const apply = (filter, shouldScroll = false) => {
      let visible = 0;
      cards.forEach((card) => {
        const tokens = (card.dataset.models || '').split(/\s+/).filter(Boolean);
        const show = filter === 'all' || tokens.includes(filter);
        card.hidden = !show;
        card.setAttribute('aria-hidden', String(!show));
        if (show) visible += 1;
      });

      buttons.forEach((button) => {
        const active = button.dataset.avz8Filter === filter;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });

      if (result) result.textContent = `${visible} ${visible === 1 ? 'product' : 'products'} shown`;
      if (empty) empty.hidden = visible !== 0;
      if (shouldScroll && shop) shop.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    buttons.forEach((button) => {
      button.addEventListener('click', () => {
        const inModelChooser = Boolean(button.closest('.avz8-model-grid'));
        apply(button.dataset.avz8Filter || 'all', inModelChooser);
      }, { signal });
    });

    root.querySelectorAll('details').forEach((detail) => {
      detail.addEventListener('toggle', () => {
        if (!detail.open) return;
        root.querySelectorAll('details[open]').forEach((other) => {
          if (other !== detail) other.open = false;
        });
      }, { signal });
    });

    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const revealTargets = root.querySelectorAll('.avz8-product, .avz8-editorial__card, .avz8-guide, .avz8-bundle');
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '80px 0px', threshold: 0.08 });
      revealTargets.forEach((target) => observer.observe(target));
      signal.addEventListener('abort', () => observer.disconnect(), { once: true });
    }

    apply('all');
  }

  function initWithin(container = document) {
    if (container.matches?.('[data-avz8-root]')) init(container);
    container.querySelectorAll?.('[data-avz8-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initWithin(), { once: true });
  } else {
    initWithin();
  }

  document.addEventListener('shopify:section:load', (event) => initWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.('[data-avz8-root]') ? event.target : event.target.querySelector?.('[data-avz8-root]');
    controllers.get(root)?.abort();
  });
})();
